import { render, staticRenderFns } from "./MttoPreventivo.vue?vue&type=template&id=839f2d6a"
import script from "./MttoPreventivo.vue?vue&type=script&lang=js"
export * from "./MttoPreventivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports